import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

export const useGetCustomerCreditHistoryQuery = (id: any) => {
  const token = getToken();

  return useQuery({
    queryKey: ["getCustomerCreditHistoryQuery", id],
    queryFn: () =>
      axiosInstance
        .get(`customers/${id}/credit-history`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),
    enabled: !!token && !!id,
  });
};
